import React from "react";
import { Button, Card, Col, Container, Row, Spinner } from "react-bootstrap";

import "../../index.css";
import { useAppSelector } from "../../redux-stores/hooks/hooks";
import { selectPage } from "../../redux-stores/reducers/PageState";
export interface BaseCardViewProps {
  pageName?: string;
  title?: string;
  body?: string;
  dynamicLoad?: boolean;
  bodyComponent?: (body: string) => JSX.Element | JSX.Element[];
  onNext?: () => void;
  onPrevious?: () => void;
  onShow?: () => void;
  disableNext?: boolean;
  disablePrevious?: boolean;
  hideNext?: boolean;
  nextBtnText?: string;
  hidePrev?: boolean;
  previousBtnText?: string;
  nextBtnVariant?: string;
  prevBtnVariant?: string;
  className?: string;
  cardStyle?: React.CSSProperties;
  containerStyle?: React.CSSProperties;
  headerStyle?: React.CSSProperties;
  bodyStyle?: React.CSSProperties;
  footerStyle?: React.CSSProperties;
}

function BaseCardView(props: BaseCardViewProps) {
  const dynamicLoad = props.dynamicLoad ?? false;
  const [title, setTitle] = React.useState(props.title ?? "");
  const [body, setBody] = React.useState<string>(props.body ?? "");
  const [loadingView, setLoadingView] = React.useState(true);
  const pageData = useAppSelector(selectPage(props.pageName));
  const onShow = props.onShow;
  const onShowCallback = React.useCallback(() => onShow && onShow(), [onShow]);
  const dynamicLoadCB = React.useCallback(() => {
    if (dynamicLoad) {
      if (!pageData) return;
      if (!loadingView) return;
      if (pageData.title && !title) {
        setTitle(pageData.title);
        setLoadingView(false);
      } else if (title) {
        setLoadingView(false);
      }
      if (pageData.body && !body) {
        setBody(pageData.body);
        setLoadingView(false);
      } else if (body) {
        setLoadingView(false);
      }
    } else {
      setLoadingView(false);
    }
    // eslint-disable-next-line
  }, [pageData, title, setTitle, body, setBody, loadingView, setLoadingView]);
  React.useEffect(() => {
    onShowCallback();
    // eslint-disable-next-line
  }, [onShowCallback]);
  React.useEffect(() => {
    dynamicLoadCB();
    return () => {};
    // eslint-disable-next-line
  }, [dynamicLoad, props.title, props.body, props.pageName]);

  return (
    <Container className="card-center" style={props.containerStyle}>
      <Card className={props.className} style={props.cardStyle}>
        <Card.Header style={{ ...props.headerStyle }}>
          <Card.Title
            as={"h2"}
            style={{ fontWeight: "bold" }}
            data-testid="Card-Title"
          >
            {loadingView ? (
              <Spinner animation="border" variant="primary" about="Loading" />
            ) : (
              title
            )}
          </Card.Title>
        </Card.Header>
        <Card.Body
          data-testid="Card-Body"
          style={{
            overflow: "auto auto",
            justifyContent: "center",
            display: "flex",
            ...props.bodyStyle,
          }}
        >
          {loadingView ? (
            <Spinner animation="border" variant="primary" about="Loading" />
          ) : props.bodyComponent ? (
            props.bodyComponent(body)
          ) : (
            body
          )}
        </Card.Body>
        <Card.Footer style={{ ...props.footerStyle }}>
          <Container fluid>
            <Row>
              <Col>
                {!props.hidePrev && (
                  <Button
                    className="btn-controll"
                    variant={props.prevBtnVariant ?? "secondery"}
                    disabled={props.disablePrevious}
                    onClick={() => props.onPrevious && props.onPrevious()}
                  >
                    {props.previousBtnText ?? "Previous"}
                  </Button>
                )}
              </Col>
              <Col>
                <div style={{ display: "flex", flexDirection: "row-reverse" }}>
                  {!props.hideNext && (
                    <Button
                      className="btn-controll"
                      variant={props.nextBtnVariant ?? "primary"}
                      disabled={loadingView || props.disableNext}
                      onClick={() => props.onNext && props.onNext()}
                    >
                      {props.nextBtnText ?? "Next"}
                    </Button>
                  )}
                </div>
              </Col>
            </Row>
          </Container>
        </Card.Footer>
      </Card>
    </Container>
  );
}

export default BaseCardView;
